import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor() {}

  async ngOnInit() {}

  /*async init() {
    console.log('Initializando...');
    // if (!production) {
    //   this.storageSercice.setObjLogin({
    //     access_token: 'eyJraWQiOiJyc2ExIiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiIwNDYyOTY2ODEwMSIsImF1ZCI6InNlcnZpY29z' +
    //       'LmRhdGFzdXMuc2F1ZGUuZ292LmJyIiwic2NvcGUiOlsiZW1haWwiLCJvcGVuaWQiLCJwcm9maWxlIl0sImFtciI6InBhc3N3Z' +
    //       'CIsImlzcyI6Imh0dHBzOlwvXC9zc28uYWNlc3NvLmdvdi5iclwvIiwiZXhwIjoxNTg2MTQ0NDM0LCJpYXQiOjE1ODYxNDA4Mz' +
    //       'QsImp0aSI6ImFkYjI0ZDBkLTAxYjctNGM1Ni1hY2E3LWZhNzZmNjdlZjRmNSJ9.hT6WTJ7Yr5ZWH0DfQwS6sGA6BnmJicLOEG' +
    //       'CnfBx5g-t18f9QnGp8sc6qUy1Eimh-V6RqsHUHwZ3H3xauFikctF1a1ebKKWCr_UCbLjP7V14P3dZbmjLBGOosIK_6GYeDEh9' +
    //       'TLRR716HinYpk35oUsUq0IAHaaXF3Ip-AnXWO-llsRFBCUBp_zt2MbSU8htH5RpJJwapjx2ilEVhMBZ9dcF1CFQHoe0y9XN9Qb' +
    //       'EIqCzSwsjtD1u3zx8lCFs6bSuiNHLeWi88nfpcmiVNpXjB-63-H07OOfPRRG0DV1z4NpzOUCdWdYhzcs4qQekI6KlBoxTUSpvW' +
    //       'MIuiiHW66ATf41A',
    //     scope: 'email openid profile',
    //     id_token: 'eyJraWQiOiJyc2ExIiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiIwNDYyOTY2ODEwMSIsImVtYWlsX3ZlcmlmaWVkIjoi' +
    //       'dHJ1ZSIsImFtciI6InBhc3N3ZCIsInByb2ZpbGUiOiJodHRwczpcL1wvYWNlc3NvLmdvdi5iciIsImtpZCI6InJzYTEiLCJpc' +
    //       '3MiOiJodHRwczpcL1wvc3NvLmFjZXNzby5nb3YuYnJcLyIsIm5vbmNlIjoiMTU4NjE0MDgxNzUzMSIsInBpY3R1cmUiOiJod' +
    //       'HRwczpcL1wvc3NvLmFjZXNzby5nb3YuYnJcL3VzZXJpbmZvXC9waWN0dXJlIiwiYXVkIjoic2Vydmljb3MuZGF0YXN1cy5zYX' +
    //       'VkZS5nb3YuYnIiLCJhdXRoX3RpbWUiOjE1ODYxNDA4MjksInNjb3BlIjpbImVtYWlsIiwib3BlbmlkIiwicHJvZmlsZSJdLCJu' +
    //       'YW1lIjoiSGFpbGxhbmRlcnNvbiBDYXN0cm8gZSBTaWx2YSIsImV4cCI6MTU4NjE0MTQzNCwiaWF0IjoxNTg2MTQwODM0LCJqdG' +
    //       'kiOiIzNDY0ZGMxZC04Nzc2LTRlMGUtYmU2OS0wZTNkOTYzMmNmODMiLCJlbWFpbCI6ImhhaWxsYW5kZXJzb25jYXN0cm8yMDEy' +
    //       'QGdtYWlsLmNvbSJ9.iI4aqtMwIAgM07Ri7beN-ve4DqFjdZSZ0Tur17kJE2zRLuBXsBVCNrMwNyH0Y62_B2tq8gXpa7-2ySD_R' +
    //       'Fgv35fJ97hd33rtGSi7Z3AJWi7FEpiGaPuQEOmn_IIRjam5bjVbW7lNiRzf_J0I44TXUTYiB7T1tC6oW7zQhHH9s30Y27aTRn' +
    //       'SUAlT8XoPtDn6kbcbUOWf5QukDh1v1sCVpgJVMLZEQRTP2ckkqvOZl3hv_oq_S54lNomEEpUxBe1EXWcLXMS-XE9GHac7EvhRQ' +
    //       'LGbmkVe2vW3MSeNM8KFqABGrEloNQ7KRfkFfZQMYnsaf1Ajij16WVBACvwZrTyfAMA',
    //     token_type: 'Bearer',
    //     expires_in: 3599
    //   });
    //   this.storageSercice.setTokenBc(
    //     'eyJraWQiOiJyc2ExIiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiIwNDYyOTY2ODEwMSIsImF1ZCI6InNlcnZpY29zLmRhdGFz' +
    //     'dXMuc2F1ZGUuZ292LmJyIiwic2NvcGUiOlsiZW1haWwiLCJvcGVuaWQiLCJwcm9maWxlIl0sImFtciI6InBhc3N3ZCIsImlzcyI6I' +
    //     'mh0dHBzOlwvXC9zc28uYWNlc3NvLmdvdi5iclwvIiwiZXhwIjoxNTg2MTQ0NDM0LCJpYXQiOjE1ODYxNDA4MzQsImp0aSI6ImFkYjI' +
    //     '0ZDBkLTAxYjctNGM1Ni1hY2E3LWZhNzZmNjdlZjRmNSJ9.hT6WTJ7Yr5ZWH0DfQwS6sGA6BnmJicLOEGCnfBx5g-t18f9QnGp8sc6q' +
    //     'Uy1Eimh-V6RqsHUHwZ3H3xauFikctF1a1ebKKWCr_UCbLjP7V14P3dZbmjLBGOosIK_6GYeDEh9TLRR716HinYpk35oUsUq0IAHaaX' +
    //     'F3Ip-AnXWO-llsRFBCUBp_zt2MbSU8htH5RpJJwapjx2ilEVhMBZ9dcF1CFQHoe0y9XN9QbEIqCzSwsjtD1u3zx8lCFs6bSuiNHLe' +
    //     'Wi88nfpcmiVNpXjB-63-H07OOfPRRG0DV1z4NpzOUCdWdYhzcs4qQekI6KlBoxTUSpvWMIuiiHW66ATf41A'
    //   );
    //   this.storageSercice.setUserBc({
    //     cpf: '04629668101',
    //     nome: 'Haillanderson Castro e Silva',
    //     email: 'haillandersoncastro2012@gmail.com',
    //     foto: null,
    //     dataLogin: '2020-04-06T02:40:35.207Z'
    //   });
    //   await this.authService.loginScab();
    //   await this.authService.loginBarramento();
    // } else {
    await this.authService.loginScab();
    console.log('Logged in SCAB ', this.authService.getLocalTokenScab());
    await this.authService.loginBarramento();
    console.log('Logged in Barramento ', this.authService.getLocalTokenBarramento());
    // }
  }*/
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts